module.exports = __webpack_public_path__ + "img/5dd35c86f8b2081534885d3f2d8ecde.c1c90b1f.png";